import cogotoast from 'cogo-toast';
import $ from 'jquery';
import {
  compose,
  flatten,
  get,
  map,
} from 'lodash/fp';

import { createRgFormAPI, createRgFormDataAPI } from '~/api/core/rgRequest';
import { getServerOrigin } from '~/api/core/utils';

import AgentsClient from '~/state/Agents/client';
import CampaignClient from '~/state/Campaign/client';

import { querySubscription, render } from '~/theseus';

import CampaignName from '~/theseus/components/CampaignName';
import LeadAds from '~/theseus/components/LeadAds';

// This is used for multi as we want to ensure that the LeadAd and Campaign
// components are not initialized multiple times
let leadAdInitialized = false;

let accountId = null;
let pageId = null;

querySubscription('account_id', (id) => { accountId = id; });
querySubscription('page_id', (id) => { pageId = id; });

const getSearchIdAPI = createRgFormAPI('/get_search_id');

async function getSearchId(initSearchId, link, linkType) {
  if (initSearchId && ['multi-custom', 'custom', 'video'].every(type => type !== linkType)) {
    return initSearchId;
  }

  const re = /search\/details\/([a-zA-Z0-9]*)/;
  const found = link.match(re);

  if (found && found.length > 0) {
    return found[1];
  }

  const { data } = await getSearchIdAPI.post({ pageId, accountId, link });

  return data.search_id;
}

function examineLinkForAgentId(link) {
  const url = new URL(link);
  if (url.searchParams.has('agent_id')) {
    AgentsClient.agents.setId(url.searchParams.get('agent_id'));
  }
}

export function checkLinkType(link, expected, type) {
  if (expected != type) {
    alert(
      `Using a ${type} on a ${expected} ad. \n`
      + `Redirecting you to ${type} ad.`,
    );
    window.onbeforeunload = null;
    window.location.assign(
      `${window.location.origin
      }/${type}.html`
      + `?link=${encodeURIComponent(link)}`,
    );
  }
}

const extractImages = compose([
  flatten,
  map(get('images')),
]);

export default async function analyzeLink(url, linkType, params, leadFormEnabled = false) {
  const analyzeLinkAPI = createRgFormDataAPI(url);

  return analyzeLinkAPI.post(params)
    .then(({ data: res }) => {
      getSearchId(res.search_id, res.link, linkType)
        .then(CampaignClient.searchId.set);

      examineLinkForAgentId(res.link);

      const images = extractImages(res.properties) || [];

      if (!leadAdInitialized) {
        render(
          '#lead-ads',
          <LeadAds
            link={res.link}
            linkType={linkType}
            propertyImages={images}
            enabledByDefault={leadFormEnabled}
          />,
        );

        render('#campaign-name', <CampaignName />);

        CampaignClient.link.analyzed(res.link);

        leadAdInitialized = true;
      }

      return res;
    })
    .catch(determineError)
    .finally(() => {
      $('.link__add-link').removeClass('link__add-link--loading');
      $('.link__input').removeClass('link__input--loading');
    });
}

/*
 * Errors in 0xfbadbae
 *
 * custom_error :NoDomainNameInLink,          422
 * custom_error :SiteHostMismatch,            422
 * custom_error :WTFLink,                     422
 * custom_error :PropertyInfoMissing,         500
 * custom_error :PropertyMissing,             404
 * custom_error :TooManyProperties,           422
 * custom_error :PropertyLinkOrImagesMissing, 404
 * custom_error :MalformedURL,                422
 * custom_error :SearchIDMissing,             422
 */
function determineError(res) {
  // The data / error text should already be extracted here since we are
  // using the extractData middleware in our API
  const errorMessage = res.data;

  switch (res.status) {
    case 404:
    case 422:
      cogotoast.warn(errorMessage);
      break;
    case 500:
      cogotoast.error(errorMessage);
      break;
    default:
      cogotoast.error('An unknown error has occured when processing your link');
  }
}
